import BaseModel from '../../util/model';

export type StateModel = object;

export default class Model extends BaseModel implements StateModel {}
